import { defineStore } from 'pinia'
import { useCardStore } from './card'

export const useProcessStore = defineStore({
  id: 'process',
  state: (): ProcessState => ({
    disclaimer: false, // 免责声明
    process: '',
    startPage: '',
    endPage: '',
    todo: '',
    params: {}, // 流程参数 目前用于存储找回密码上一步的数据
    historyLengthOnStart: 0, // 进入流程时的历史栈长度，用于计算返回步数
  }),

  getters: {},

  actions: {
    setPage(start: string, end?: string, todo?: string) {
      this.startPage = start
      this.endPage = end || start
      this.todo = todo || this.todo || ''
      // 记录进入流程时的历史栈长度
      this.historyLengthOnStart = window.history.length
    },
    finishProcess(query = {}) {
      console.log('[清空cardStore和流程参数]')
      this.params = {}
      useCardStore().$reset()
      this.$router.push({
        path: this.endPage,
        query,
      })
    },
  },

  persist: {
    enabled: true,
  },
})
